import { toast } from 'react-hot-toast';
import { useCallback } from 'react';
import { ApolloError } from '@apollo/client';
import apolloErrorParser from 'utils/apolloErrorParser';

interface IUseErrorSnakbarReturn {
  enqueueApolloError: (error?: ApolloError) => void;
  enqueueErrorMessage: (message: string) => void;
}

function useErrorSnakbar(): IUseErrorSnakbarReturn {
  const enqueueApolloError = useCallback((error?: ApolloError) => {
    const { errorMessage } = apolloErrorParser(error);
    toast.error(errorMessage);
  }, []);

  const enqueueErrorMessage = useCallback((message: string) => {
    toast(message);
  }, []);

  return {
    enqueueApolloError,
    enqueueErrorMessage,
  };
}

export default useErrorSnakbar;
